<template>
  <b-modal
    v-model="innerValue"
    title="Privacy Policy"
    body-class="px-4 pb-4 pt-0"
    size="lg"
    hide-footer
    @shown="addTermlyScript"
  >
    <div>
      <div name="termly-embed" data-id="b9051d81-f909-45d2-b64f-3b4531bee4f7" data-type="iframe"></div>
    </div>
  </b-modal>
</template>

<script>
import { defineComponent, computed } from "@vue/composition-api";

export default defineComponent({
  name: "ModalPrivacyPolicy",
  emits: ["input"],
  props: {
    value: Boolean,
  },
  setup(props, { emit }) {
    const innerValue = computed({
      get: () => props.value,
      set: (newValue) => emit("input", newValue),
    });

    const addTermlyScript = () => {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.id = "termly-jssdk";
      script.src = "https://app.termly.io/embed-policy.min.js";

      const head = document.getElementsByTagName("head")[0];
      head.appendChild(script);
    };

    return {
      innerValue,
      addTermlyScript,
    };
  },
});
</script>
